module.exports = __webpack_public_path__ + "img/three.18da07fa.png";